export default "__VITE_ASSET__CMY3hP5$__"